module.exports = __webpack_public_path__ + "static/brascol-15off-3ccbaf76ac7b21783af1ef87bfbb70c7.jpg";